const isBrowser = typeof window !== 'undefined';

class AnalyticsService {
  constructor() {
    this.mixpanelReady = false;
    this.eventQueue = [];
  }

  init() {
    if (!isBrowser) return;

    if (window.mixpanel) {
      this.mixpanelReady = true;
      this.flushQueue();
    } else {
      const checkMixpanel = setInterval(() => {
        if (window.mixpanel) {
          this.mixpanelReady = true;
          clearInterval(checkMixpanel);
          this.flushQueue();
        }
      }, 100);

      setTimeout(() => clearInterval(checkMixpanel), 5000);
    }
  }

  flushQueue() {
    while (this.eventQueue.length > 0) {
      const { eventName, properties } = this.eventQueue.shift();
      this.trackEvent(eventName, properties);
    }
  }

  trackEvent(eventName, properties = {}) {
    if (!isBrowser) return;

    if (this.mixpanelReady && window.mixpanel) {
      try {
        window.mixpanel.track(eventName, {
          ...properties,
          timestamp: new Date().toISOString(),
        });
      } catch (error) {
        console.error('Mixpanel tracking error:', error);
      }
    } else {
      this.eventQueue.push({ eventName, properties });
    }
  }

  trackPageView(pageName, properties = {}) {
    this.trackEvent('Page View', {
      page: pageName,
      ...properties,
    });
  }

  identify(userId, traits = {}) {
    if (!isBrowser || !this.mixpanelReady || !window.mixpanel) return;

    try {
      window.mixpanel.identify(userId);
      if (Object.keys(traits).length > 0) {
        window.mixpanel.people.set(traits);
      }
    } catch (error) {
      console.error('Mixpanel identify error:', error);
    }
  }

  setUserProperties(properties = {}) {
    if (!isBrowser || !this.mixpanelReady || !window.mixpanel) return;

    try {
      window.mixpanel.people.set(properties);
    } catch (error) {
      console.error('Mixpanel set user properties error:', error);
    }
  }

  reset() {
    if (!isBrowser || !this.mixpanelReady || !window.mixpanel) return;

    try {
      window.mixpanel.reset();
    } catch (error) {
      console.error('Mixpanel reset error:', error);
    }
  }
}

const analyticsService = new AnalyticsService();

export default analyticsService;

export const trackEvent = (eventName, properties) =>
  analyticsService.trackEvent(eventName, properties);

export const trackPageView = (pageName, properties) =>
  analyticsService.trackPageView(pageName, properties);

export const identify = (userId, traits) =>
  analyticsService.identify(userId, traits);

export const setUserProperties = (properties) =>
  analyticsService.setUserProperties(properties);

export const reset = () =>
  analyticsService.reset();
